/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/log_out'
export default icon
